<template>
  <b-modal
    id="prestation-modal"
    ref="prestation-modal"
    :title="$t('title.createPrestationModal')"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('control.button.save')"
    :cancel-title="$t('control.button.cancel')"
    @ok="onSubmit"
  >
    <div class="row">
      <div class="col-md-12">
        <b-card border-variant="primary">
          <div class="row">
            <div
              class="col-md-6"
            >
              <b-form-group
                :label="$t('control.label.prestations.prestation.activity')"
                label-for="activity"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-select
                  id="activity"
                  v-model="$v.form.activityId.$model"
                  :options="activities"
                  value-field="id"
                  text-field="name"
                  :state="validateState('activityId')"
                >
                  <template #first>
                    <b-form-select-option
                      :value="null"
                      disabled
                    >
                      -- {{ $t('control.option.activity') }} --
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </div>
            <div
              class="col-md-6"
            >
              <b-form-group
                :label="$t('control.label.prestations.prestation.name')"
                label-for="name"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-input
                  id="name"
                  v-model="$v.form.name.$model"
                  :state="validateState('name')"
                />
              </b-form-group>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { masked, mask } from 'vue-the-mask';
import { validationMixin } from 'vuelidate';
import {
  required,
} from 'vuelidate/lib/validators';
import activities from '../services/Activities';
import prestations from '../services/Prestations';

export default {
  directives: { mask, masked },
  mixins: [validationMixin],
  data() {
    return {
      activities: [],
      form: {
        id: 0,
        name: null,
        activityId: null,
      },
      selected: [],
    };
  },
  mounted() {
    if (this.$store.getters['authorization/isAdministrator']) {
      this.$root.$on('updatePrestationModal', (prestation) => {
        this.update(prestation);
      });
      this.$root.$on('newPrestationModal', () => {
        this.new();
      });
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      activityId: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        id: 0,
        activityId: null,
        name: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$nextTick(async () => {
        prestations.baseUrl = this.$store.state.settings.apiBaseUrl;
        if (this.$store.getters['authorization/data'] != null) prestations.userId = this.$store.getters['authorization/data'].id;
        await prestations.put(this.form.id, this.form);
        this.closeModal();
      });
    },
    showModal() {
      this.getActivities();
      this.$bvModal.show('prestation-modal');
    },
    closeModal() {
      this.$bvModal.hide('prestation-modal');
      this.$root.$emit('forceUpdatePrestations');
    },
    new() {
      this.resetForm();
      this.showModal();
    },
    update(prestation) {
      this.form.id = prestation.id;
      this.form.activityId = prestation.activityId;
      this.form.name = prestation.name;
      this.showModal();
    },
    async getActivities() {
      activities.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await activities.getActivities();
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.activities = result[1];
      });
    },
  },
};

</script>
